import React from 'react';

import InputCheckboxField from '../../components/FormFields/InputCheckboxField';
import InputTextField from '../../components/FormFields/InputTextField';
import { formClasses } from '../../utils/BEM';

export type LoginFormData = {
    username: string;
    password: string;
    rememberPassword: boolean;
};
type LoginFormProps<T> = {
    busy: boolean;
    formData: T;
    setFormData: (formData: T) => void;
};

function LoginForm<T extends LoginFormData>({ busy, formData, setFormData }: LoginFormProps<T>) {
    return (
        <>
            <InputTextField
                autoComplete="username"
                label="E-Mail"
                name="username"
                type="email"
                value={formData.username}
                onChange={(username) => setFormData({ ...formData, username })}
            />
            <InputTextField
                autoComplete="current-password"
                label="Password"
                name="password"
                type="password"
                value={formData.password}
                onChange={(password) => setFormData({ ...formData, password })}
            />
            <div {...formClasses('fieldlike')}>
                <InputCheckboxField
                    fieldModifiers={{ 'single-line': true }}
                    inputLabel={formData.rememberPassword ? 'Yes' : 'No'}
                    label="Remember password"
                    value={formData.rememberPassword}
                    onChange={(rememberPassword) => setFormData({ ...formData, rememberPassword })}
                />
            </div>
            <div {...formClasses('fieldlike', undefined, 'text-end')}>
                <button {...formClasses('button')} disabled={busy}>
                    Log in
                </button>
            </div>
        </>
    );
}

export default LoginForm;
